import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const MessageSequence = Loadable(
  lazy(() =>
    import("./MessageSequence").then(({ MessageSequence }) => ({
      default: MessageSequence,
    }))
  )
);

export const MessageSequenceRoutes = [
  {
    path: "/message-sequence",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <MessageSequence />
      </AuthorizedRoute>
    ),
  },
];
